import React, {FC,useState ,MouseEvent}  from 'react';
import { useNavigate } from 'react-router-dom';

// import MUI
import {Button, AppBar, Toolbar, Box, IconButton, Typography, 
  Menu, MenuItem, Avatar, Divider, ListItemIcon} from '@mui/material';
import {Save as SaveIcon, ViewList as ViewListIcon, Print as PrintIcon ,AccountCircle as AccountCircleIcon, 
  Home as HomeIcon, ManageAccounts as ManageAccountsIcon, Logout as LogoutIcon,
  MergeType as MergeTypeIcon, Transform as TransformIcon } from '@mui/icons-material';

  
// import library
import { useTranslation  } from 'react-i18next';

// import component

// import user library
import {useUserStore} from '../library/store';

const TopMenu: FC = () => {

  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  const {currentUser ,getCurrentEntity, isBackendOperation} = useUserStore();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [menuClickCount, setMenuClickCount] = useState<number>(-1);

  const handleClick = (event : any) => {
    
    setAnchorEl(event.currentTarget);
  }
  
  const isMenuAllowed = (entity : string) : boolean => {    
    
    return currentUser.userMenus.find( x => x.entity === entity) !== undefined;
  }

  

  const disconnectUser = useUserStore(state => state.disconnectUser);

  const menuItemClickDisconnect = (event : any) => {
    disconnectUser(); 
    navigate('/');        
    }

  const menuItemClickChangePassword = (event: any) => {
    navigate('/changePassword');  
  }

  const goToHome = (event: any) => {
    navigate('/');  
  }
  

  const handleClose = () => {
    setAnchorEl(null);
  }

  const menuClick = (event: MouseEvent<HTMLButtonElement>) => {    
    event.preventDefault();

    setMenuClickCount(menuClickCount - 1);
    const eltId = (event.target as HTMLButtonElement).id;
    
    const url = eltId.replace('btn','');
    
    navigate(`${url}/${menuClickCount}`);    
  }
  

    return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ height: '32px', minHeight: '32px', justifyContent : 'center' }}>
        <Toolbar>
          <IconButton size="large" edge="start" color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={goToHome} id="btn"
          >
            <HomeIcon />
          </IconButton>
          <Box sx={{ flexGrow: 1 }} />
          
          
          <Box sx={{ flexGrow: 0.5 }} /> 
          <Divider orientation="vertical" style={{ height: "30px", color: "red", width: "5px" }} /> 
          <Button color="inherit" onClick={menuClick} id="btnBankRole" disabled={!isMenuAllowed('BankRole')} >{t('Role')}</Button>
          <Divider orientation="vertical" style={{ height: "30px", color: "red", width: "5px" }} />
          <Button color="inherit" onClick={menuClick} id="btnBankUser" disabled={!isMenuAllowed('BankUser')}>{t('User')}</Button>
          {/* <Button color="inherit" onClick={menuClick} id="btnBankAgency" disabled={!isMenuAllowed('BankAgency')}>{t('Agency')}</Button> 
          <Button color="inherit" onClick={menuClick} id="btnBankPerson" disabled={!isMenuAllowed('BankPerson')}>{t('Person')}</Button>*/}
          <Divider orientation="vertical" style={{ height: "30px", color: "red", width: "5px" }} />
          <Button color="inherit" onClick={menuClick} id="btnBankPolicy" disabled={!isMenuAllowed('BankPolicy')}>{t('Contract')}</Button>
          <Divider orientation="vertical" style={{ height: "30px", color: "red", width: "5px" }} />
          <Button color="inherit" onClick={menuClick} id="btnBankGroupPolicy" disabled={!isMenuAllowed('BankGroupPolicy')}>{t('GroupPolicy')}</Button>
          <Divider orientation="vertical" style={{ height: "30px", color: "red", width: "5px" }} />
          <Box sx={{ flexGrow: 1 }} />
          <IconButton aria-label="account of current user" aria-controls="menu-account"
              aria-haspopup="true" color="inherit" onClick={handleClick}>
              <AccountCircleIcon />
          </IconButton>
          <Menu anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        
        <MenuItem onClick={menuItemClickChangePassword}>
          <ListItemIcon color="primary">
            <ManageAccountsIcon fontSize="small" color="primary" />
          </ListItemIcon>
          {t('Change Password')}
        </MenuItem>
        <Divider />
        
        
        <MenuItem onClick={menuItemClickDisconnect}>
          <ListItemIcon color="primary">
            <LogoutIcon fontSize="small" color="primary"/>
          </ListItemIcon>
          {t('Logout')}
        </MenuItem>
      </Menu>
        </Toolbar>
      </AppBar>
    </Box>
    );
  }
  
  export default TopMenu;